import { useEffect, useState } from 'react';

const HEARTBEAT_INTERVAL_MS = 30000;

const getVisitorId = () => {
  const storageKey = 'pingfence-presence-id';
  const existingId = window.localStorage.getItem(storageKey);
  if (existingId) return existingId;

  const visitorId = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 14)}`;
  window.localStorage.setItem(storageKey, visitorId);
  return visitorId;
};

const useActiveUsers = () => {
  const [activeUsers, setActiveUsers] = useState(null);

  useEffect(() => {
    let isMounted = true;
    const visitorId = getVisitorId();

    const sendHeartbeat = async () => {
      try {
        const response = await fetch('/api/presence', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ visitorId })
        });

        if (!response.ok) return;
        const data = await response.json();
        if (isMounted && Number.isInteger(data.activeUsers)) {
          setActiveUsers(data.activeUsers);
        }
      } catch (error) {
        // Presence is optional and should never affect the rest of the app.
      }
    };

    sendHeartbeat();
    const heartbeatTimer = window.setInterval(sendHeartbeat, HEARTBEAT_INTERVAL_MS);

    return () => {
      isMounted = false;
      window.clearInterval(heartbeatTimer);
    };
  }, []);

  return activeUsers;
};

export default useActiveUsers;